import { Globe, MessageSquare, CreditCard } from "lucide-react";

const ServiceCard = ({ icon, title, description }) => (
    <div className="relative group cursor-pointer">
        <div className="bg-gradient-to-br from-gray-900/50 to-gray-800/30 backdrop-blur-sm border border-gray-700/50 rounded-2xl p-8 hover:border-blue-500/50 hover:shadow-xl hover:shadow-blue-500/10 transition-all duration-300 h-full">
            <div className="flex flex-col items-center text-center space-y-4">
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-600 via-blue-500 to-purple-600 flex items-center justify-center group-hover:scale-110 transition-all duration-300 shadow-lg shadow-blue-500/30">
                    {icon}
                </div>
                <h3 className="text-white font-semibold text-lg">{title}</h3>
                <p className="text-gray-300 text-sm leading-relaxed">{description}</p>
            </div>
        </div>
    </div>
);

export default function CallToAction() {
    return (
        <div className="relative py-20 overflow-hidden">
            {/* Subtle accent lines */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-500/30 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-purple-500/30 to-transparent"></div>
            
            {/* Subtle glow effects */}
            <div className="absolute top-1/2 left-1/4 w-64 h-64 bg-blue-600/5 rounded-full blur-3xl -translate-y-1/2"></div>
            <div className="absolute top-1/2 right-1/4 w-64 h-64 bg-purple-600/5 rounded-full blur-3xl -translate-y-1/2"></div>

            <div className="relative container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-6xl mx-auto">
                    {/* Header */}
                    <div className="text-center mb-16 space-y-4">
                        <h2 className="text-3xl md:text-4xl font-bold text-white">
                            Looking for something else?
                        </h2>
                        <p className="text-gray-300 md:text-lg max-w-2xl mx-auto">
                            Explore our additional services designed to support your business needs
                        </p>
                    </div>

                    {/* Service Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <ServiceCard
                            icon={<Globe className="w-8 h-8 text-white" />}
                            title="Domain Registration"
                            description="Secure your perfect domain name and establish your online presence"
                        />

                        <ServiceCard
                            icon={<MessageSquare className="w-8 h-8 text-white" />}
                            title="Website Feedback"
                            description="Share your thoughts and help us improve your digital experience"
                        />

                        <ServiceCard
                            icon={<CreditCard className="w-8 h-8 text-white" />}
                            title="Payment Enquiries"
                            description="Get assistance with billing, invoices, and payment options"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}